import type { AnyAction } from '@reduxjs/toolkit';
import { useEffect } from 'react';

import { makeMfReduxActionHandlers, useMfReduxActionDispatcher } from 'ovpn-ui-toolkit';

import { addAppListener, useAppDispatch } from '../store';

export function useMfEvents(mfName: string, dispatchedActions: string[] = []) {
    const dispatch = useAppDispatch();

    useMfReduxActionDispatcher(dispatch, mfName);

    const [actionMatcher, actionHandler] = makeMfReduxActionHandlers(mfName, dispatchedActions);

    // biome-ignore lint/correctness/useExhaustiveDependencies: intended
    useEffect(
        () =>
            dispatch(
                addAppListener({
                    matcher: (action: AnyAction): action is AnyAction => actionMatcher(action),
                    effect: actionHandler,
                }),
            ),
        [dispatch],
    );
}
